var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, PrimaryColumn, Unique, UpdateDateColumn } from 'typeorm';
let Asset = class Asset {
    id;
    createdDate;
    updatedDate;
    hostname;
    address;
    port;
    secure;
    project;
    projectId;
    status;
    isFresh(maxAgeDays = 7, now = new Date()) {
        const ageInDays = (now.getTime() - this.updatedDate.getTime()) / (1000 * 60 * 60 * 24);
        return ageInDays < maxAgeDays;
    }
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Asset.prototype, "id", void 0);
__decorate([
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Asset.prototype, "createdDate", void 0);
__decorate([
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Asset.prototype, "updatedDate", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Asset.prototype, "hostname", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Asset.prototype, "address", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], Asset.prototype, "port", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], Asset.prototype, "secure", void 0);
__decorate([
    Index(),
    ManyToOne('Project', (project) => project.assets, { nullable: false, onDelete: 'CASCADE' }),
    JoinColumn({ name: 'projectId' }),
    __metadata("design:type", Function)
], Asset.prototype, "project", void 0);
__decorate([
    Column('uuid'),
    __metadata("design:type", String)
], Asset.prototype, "projectId", void 0);
__decorate([
    Column({ type: 'enum', enum: ['active', 'inactive'], default: 'active' }),
    __metadata("design:type", String)
], Asset.prototype, "status", void 0);
Asset = __decorate([
    Unique(['projectId', 'hostname', 'address', 'port', 'secure']),
    Entity()
], Asset);
export { Asset };
//# sourceMappingURL=data:application/json;base64,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